$(document).ready(function () {
   var galleryCheck = $("div.lookbook").length;

   extensions = ["_pico.", "_icon.", "_thumb.", "_small.", "_compact.", "_medium.", "_large.", "_grande.", "_1024x1024.", "_2048x2048." ];

 if (galleryCheck > 0) {
   gallery = $("div.lookbook");
   var images = gallery.find('img');

   images.each(function () {
       imgSRC = $(this).attr('src');

       for ( var i = 0; i < extensions.length; i++ ){
         var newSRC = imgSRC.replace( extensions[i] ,'.');
         if (newSRC.length<imgSRC.length) { break; };
       }
       $(this).wrap('<div class="product-index desktop-4 tablet-2 mobile-full"><a href="' + newSRC + '" data-lightbox="gallery" rel="nofollow" data-title="'+$(this).attr('alt')+'"></a>');
   });


   var p = gallery.find('p');

   p.each(function(){
     if ($(this).find('img').length < 1)
     {
       $(this).attr('class', 'product-index desktop-full tablet-full mobile-full');
     }
   });

 }
gallery = $("div.lookbook,#otherLookBook");
  var images = gallery.find('img');

 images.each(function () {
    imgSRC = $(this).attr('src');
    $(this).wrap('<div style="background-image:url('+imgSRC+')" class="LookBookItem"></div>');
  $(this).remove();
 }
);

});
